﻿import React from 'react';
import PropTypes from 'prop-types';
import unsafeCharRegex from '../constants/unsafeCharRegex';

export default class TextArea extends React.Component {
    constructor(props) {
        super(props);

        this.onValueChange = this.onValueChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
    }

    testRegex(val) {
        let pattern = unsafeCharRegex;
        let regex = new RegExp(pattern);
        let test = regex.test(val);
        return test;
    }

    onValueChange(e) {
        let val = e.target.value;
        if (this.testRegex(val)) {
            e.preventDefault();
        }
        else {
            this.props.onChange(val);
        }
    }

    onKeyPress(e) {
        let key = e.key;
        if (this.testRegex(key)) {
            e.preventDefault();
        }
    }

    onBlur(e) {
        let val = e.target.value;
        this.props.onBlur(val);
    }

    onFocus(e) {
        let val = e.target.value;
        this.props.onFocus(val);
    }

    render() {
        let successState = null;
        if (this.props.isValid !== null && this.props.isValid !== undefined) {
            if (this.props.isValid) {
                successState = "is-valid";
            }
            else {
                successState = "is-invalid";
            }
        }
        let className = "";
        if (!this.props.staticLabel) {
            className = "animated-placeholder ";
        }
        if (this.props.className) {
            className += this.props.className;
        }
        return (
            <div className={className}>
                {this.props.staticLabel &&
                    <label htmlFor={this.props.id}>
                        {this.props.label}
                    </label>
                }
                <textarea
                    id={this.props.id}
                    className={successState ? "form-control " + successState : "form-control"}
                    value={this.props.value}
                    onChange={this.onValueChange}
                    onKeyPress={this.onKeyPress}
                    required={this.props.required}
                    maxLength={this.props.maxLength ? this.props.maxLength : null}
                    disabled={this.props.disabled}
                    onBlur={this.onBlur}
                    onFocus={this.onFocus}
                />
                {!this.props.staticLabel &&
                    <label htmlFor={this.props.id}>
                        {this.props.label}
                    </label>
                }
                <div className="invalid-feedback">
                    {this.props.invalidFeedback}
                </div>
            </div>
        );
    }
}

TextArea.propTypes = {
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    invalidFeedback: PropTypes.string,
    isValid: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    staticLabel: PropTypes.bool,
    value: PropTypes.string,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
};

TextArea.defaultProps = {
    onBlur: () => { },
    onFocus: () => { },
    onChange: () => { },
    autoComplete: null
};